// @ts-nocheck
import ConfluenceIcon from "$assets/icons/confluence.svelte";
import SlackIcom from "$assets/icons/slack.svelte";
import GoogleDriveIcon from "$assets/icons/g-drive.svelte";
import SalesforceIcon from "$assets/icons/salesforce.svelte";
import TeamsIcon from "$assets/icons/teams.svelte";
import NotionIcon from "$assets/icons/notion.svelte";
import SharepointIcon from "$assets/icons/sharepoint.svelte";
import JiraIcon from "$assets/icons/jira.svelte";
import GCalIcon from "$assets/icons/g-cal.svelte";
import GDocsIcon from "$assets/icons/g-docs.svelte";
import GSheetsIcon from "$assets/icons/g-sheets.svelte";
import ZendeskIcon from "$assets/icons/zendesk.svelte";

import javascript from "svelte-highlight/languages/javascript";
import typescript from "svelte-highlight/languages/typescript";
import python from "svelte-highlight/languages/python";

import TS_CODE_BLOCKS_CAPTURE_CALLBACK from "$utils/code_blocks/capture_callback.ts?raw";

import TS_CONNECT_DS from "$utils/code_blocks/connect_ds.ts?raw";

import TS_INIT from "$utils/code_blocks/sdk_init.ts?raw";
import PY_INIT from "$utils/code_blocks/sdk_init.py?raw";

import TS_QUERY from "$utils/code_blocks/query.ts?raw";
import JS_QUERY from "$utils/code_blocks/query.js?raw";
import PY_QUERY from "$utils/code_blocks/query.py?raw";

import TS_OPENAI from "$utils/code_blocks/openai.ts?raw";
import JS_OPENAI from "$utils/code_blocks/openai.js?raw";
import PY_OPENAI from "$utils/code_blocks/openai.py?raw";

import OktaLogo from "$images/Okta_Aura_Black_S.png";
import MicrosoftLogo from "$images/Microsoft_Logo_512px.png";
import GoogleLogo from "$images/google.png";
import FingerprintLogo from "$images/fingerprint.png";

import ConfluenceLogo from "$images/confluence.png";
import SlackLogo from "$images/slack.png";
import GoogleDriveLogo from "$images/google-drive.png";
import MicrosoftTeamsLogo from "$images/microsoft-teams.png";
import JiraLogo from "$images/jira.png";
import SalesforceLogo from "$images/salesforce.png";
import SharepointLogo from "$images/sharepoint.png";

import TS_CODE_BLOCK_REFRESH_TOKEN from "$utils/code_blocks/refresh_token.ts?raw";

export const ROLES = [
  { value: ["team:read", "team:write", "users:write", "apps:write", "app_keys:write"], label: "Admin" },
  { value: ["team:read", "users:read", "apps:write", "app_keys:write"], label: "Developer" },
  { value: ["team:read", "users:write", "apps:read"], label: "Billing" },
];

export const ORG_ROLES = [
  {
    value: ["org:read", "org:write", "org:security_findings"],
    label: "Admin",
  },
  {
    value: ["org:read", "org:security_findings"],
    label: "Security Reviewer",
  },
];

const AVAILABLE_DATA_SOURCES = [
  {
    value: "confluence",
    title: "Confluence",
    subtitle: "atlassian.com",
    icon: ConfluenceIcon,
    enabled: true,
    preview: false,
  },
  {
    value: "slack",
    title: "Slack",
    subtitle: "slack.com",
    icon: SlackIcom,
    enabled: false,
    preview: false,
  },
  {
    value: "teams",
    title: "Microsoft Teams",
    subtitle: "ms-teams.com",
    icon: TeamsIcon,
    enabled: false,
    preview: false,
  },
  {
    value: "notion",
    title: "Notion",
    subtitle: "notion.com",
    icon: NotionIcon,
    enabled: false,
    preview: false,
  },
  {
    value: "sharepoint",
    title: "Sharepoint",
    subtitle: "sharepoint.com",
    icon: SharepointIcon,
    enabled: true,
    preview: false,
  },
  {
    value: "jira",
    title: "Jira",
    subtitle: "jira.com",
    icon: JiraIcon,
    enabled: false,
    preview: false,
  },
  {
    value: "google-drive",
    title: "Google Drive",
    subtitle: "drive.google.com",
    icon: GoogleDriveIcon,
    enabled: false,
    preview: false,
  },
  {
    value: "gcal",
    title: "Google Calendar",
    subtitle: "calendar.google.com",
    icon: GCalIcon,
    enabled: false,
    preview: false,
  },
  {
    value: "gdocs",
    title: "Google Sheets",
    subtitle: "docs.google.com",
    icon: GDocsIcon,
    enabled: false,
    preview: false,
  },
  {
    value: "gsheets",
    title: "Google Docs",
    subtitle: "sheets.google.com",
    icon: GSheetsIcon,
    enabled: false,
    preview: false,
  },
  {
    value: "salesforce",
    title: "Salesforce",
    subtitle: "salesforce.com",
    icon: SalesforceIcon,
    enabled: false,
    preview: false,
  },
  {
    value: "zendesk",
    title: "Zendesk",
    subtitle: "zendesk.com",
    icon: ZendeskIcon,
    enabled: false,
    preview: true,
  },
];

export const DATA_SOURCES = AVAILABLE_DATA_SOURCES.filter((x) => x.enabled);

// BACKEND CODE BLOCKS
export const CODE_BLOCKS_INSTALL = [
  {
    language: javascript,
    languageLabel: "npm",
    code: `$ npm install @redactive/redactive`,
  },
  {
    language: python,
    languageLabel: "pip",
    code: `$ pip install redactive`,
  },
];

export const CODE_BLOCKS_SDK_INIT = (data_sources, apiKey) => [
  {
    language: typescript,
    code: TS_INIT.replace("{{apiKey}}", apiKey).replace(
      "{{data_sources}}",
      data_sources.map((ds) => `"${ds}"`).join(" | "),
    ),
  },
  {
    language: python,
    code: PY_INIT.replace("{{apiKey}}", apiKey).replace(
      "{{data_sources}}",
      data_sources.map((ds) => `"${ds}"`).join(" | "),
    ),
  },
];

export const CODE_BLOCKS_CAPTURE_CALLBACK = (data_sources, apiKey) => [
  {
    language: typescript,
    code: TS_CODE_BLOCKS_CAPTURE_CALLBACK.replace("{{apiKey}}", apiKey),
  },
];

export const CODE_BLOCKS_REFRESH_TOKEN = (data_sources, apiKey) => [
  {
    language: typescript,
    code: TS_CODE_BLOCK_REFRESH_TOKEN.replace("{{apiKey}}", apiKey),
  },
];

export const CODE_BLOCKS_CONNECT_DS = (data_sources, apiKey, redirect_uri, endpoint) => [
  {
    language: typescript,
    code: TS_CONNECT_DS.replace("{{apiKey}}", apiKey)
      .replace("{{data_sources}}", data_sources.map((ds) => `"${ds}"`).join(" | "))
      .replace("{{redirect_uri}}", redirect_uri ?? "")
      .replace("{{endpoint}}", endpoint ?? ""),
  },
];

export const CODE_BLOCKS_QUERY = (data_sources, apiKey) => [
  {
    language: javascript,
    // languageLabel: "node",
    code: JS_QUERY.replace("{{apiKey}}", apiKey),
  },
  {
    language: typescript,
    code: TS_QUERY.replace("{{apiKey}}", apiKey),
  },
  {
    language: python,
    code: PY_QUERY.replace("{{apiKey}}", apiKey),
  },
];

export const CODE_BLOCKS_OPENAI = (data_sources, apiKey) => [
  {
    language: javascript,
    // languageLabel: "node",
    code: JS_OPENAI.replace("{{apiKey}}", apiKey),
  },
  {
    language: typescript,
    code: TS_OPENAI.replace("{{apiKey}}", apiKey),
  },
  {
    language: python,
    code: PY_OPENAI.replace("{{apiKey}}", apiKey),
  },
];

export const delegatedPermissions = [
  {
    scopes: ["email", "openid", "profile", "User.Read"],
    description: "These allow us to sign users into Permissions Assurance",
  },
  {
    scopes: ["offline_access"],
    description: "This allows us to manage user sessions across multiple data sources.",
    selected: true,
  },
  {
    scopes: ["Files.Read", "Files.Read.All"],
    description: "These ensure we only ever return data a user can access.",
  },
];

// Sharepoint scopes:
// https://learn.microsoft.com/en-us/graph/permissions-reference#all-permissions
export const applicationPermissions = [
  {
    scopes: ["User.Read.All"],
    description: "This allows us to understand a users role in your organization",
  },
  {
    scopes: ["Files.Read.All"],
    description: "This is how we scan your data and build up a semantic index.",
  },
  {
    scopes: ["GroupMember.Read.All", "Sites.Read.All"],
    description: "This allow us to know which users are in which groups.",
  },
];

const googleDelegatedPermissions = [
  {
    scopes: [
      "https://www.googleapis.com/auth/admin.directory.group.readonly",
      "https://www.googleapis.com/auth/admin.directory.domain.readonly",
      "https://www.googleapis.com/auth/admin.directory.user.readonly",
    ],
    description: "These allow us to access group membership and domain information.",
  },
  {
    scopes: ["https://www.googleapis.com/auth/drive"],
    description: "These allow us to access files in Google Drive.",
  },
];

export const ssoProviders = {
  entra: {
    name: "Microsoft Entra",
    logo: MicrosoftLogo,
    url: "microsoft.com",
    delegatedPermissions,
    applicationPermissions: [],
    id: "entra",
  },
  okta: {
    name: "Okta",
    logo: OktaLogo,
    url: "okta.com",
    inPreview: true,
    delegatedPermissions,
    applicationPermissions: [],
    id: "okta",
  },
  google: {
    name: "Google",
    logo: GoogleLogo,
    url: "google.com",
    inPreview: true,
    delegatedPermissions,
    applicationPermissions: [],
    id: "google",
  },
};

export const dataSources = {
  sharepoint: {
    name: "Sharepoint",
    logo: SharepointLogo,
    url: "microsoft.com",
    delegatedPermissions,
    applicationPermissions,
    id: "sharepoint",
  },
  gdrive: {
    name: "Google Drive",
    logo: GoogleDriveLogo,
    url: "google.com",
    delegatedPermissions: googleDelegatedPermissions,
    applicationPermissions: [],
    inPreview: false,
    id: "gdrive",
  },
  confluence: {
    name: "Confluence",
    logo: ConfluenceLogo,
    url: "atlassian.com",
    delegatedPermissions,
    applicationPermissions,
    inPreview: true,
    id: "confluence",
  },
  team: {
    name: "Microsoft Teams",
    logo: MicrosoftTeamsLogo,
    url: "microsoft.com",
    delegatedPermissions,
    applicationPermissions,
    inPreview: true,
    id: "teams",
  },
  jira: {
    name: "Jira",
    logo: JiraLogo,
    url: "atlassian.com",
    delegatedPermissions,
    applicationPermissions,
    inPreview: true,
    id: "jira",
  },
  salesforce: {
    name: "Salesforce",
    logo: SalesforceLogo,
    url: "salesforce.com",
    delegatedPermissions,
    applicationPermissions,
    inPreview: true,
    id: "salesforce",
  },
  slack: {
    name: "Slack",
    logo: SlackLogo,
    url: "slack.com",
    delegatedPermissions,
    applicationPermissions,
    inPreview: true,
    id: "slack",
  },
};

export interface ProviderSetup {
  email?: string;
  connectionId: string;
  status: "pending" | "success";
  requests?: string[];
}
